/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Inherit_HintInputs */

const cs_settings_venues_inherit_hint = /** @type {(inputs: Settings_Venues_Inherit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použije zastřešující firmu z nastavení kanceláře.`)
};

const en_settings_venues_inherit_hint = /** @type {(inputs: Settings_Venues_Inherit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uses the umbrella company from Office settings.`)
};

/**
* | output |
* | --- |
* | "Uses the umbrella company from Office settings." |
*
* @param {Settings_Venues_Inherit_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_inherit_hint = /** @type {((inputs?: Settings_Venues_Inherit_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Inherit_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_inherit_hint(inputs)
	return cs_settings_venues_inherit_hint(inputs)
});